import { VariableScope } from '../../types';

const variableScopes = [
  VariableScope.application,
  VariableScope.module,
  VariableScope.parameter
].join('|');

const digitSearchString = '[1-9][0-9]*';
const variableSearchString = `(${variableScopes})\\.([a-zA-Z][0-9a-zA-Z-_]*)`;

/**
 * Matches just the variable.
 *
 * @example '{{scope.variableName}}'.
 */
export const variableOnlySearch = new RegExp(
  `(${variableSearchString})`,
  'ig'
);

/**
 * Matches variable wrapped in braces.
 *
 * @example '{{scope.variableName}}'.
 */
export const variableSearch = new RegExp(
  `{{(${variableSearchString})}}`,
  'ig'
);

/**
 * This regex is used to match variables and digits in the format.
 *
 * @example '{{scope.variableName}}'.
 * @example '{{10}}'.
 */
export const variableAndDigitSearch = new RegExp(
  `{{(${variableSearchString}|${digitSearchString})}}`,
  'ig'
);

/**
 * This regex is used to match digits inside the format: {{1}}.
 * It matches a number that starts with a non-zero digit and is followed by zero or more digits.
 *
 * @example '10'.
 */
export const digitPlaceholderSearch = new RegExp(`^${digitSearchString}$`, 'g');
